import { Map, fromJS } from "immutable";
import * as actions from "./actions";
export default (state = Map(), { type, ...action }) => {
  switch (type) {
    case actions.FETCH_PROFILE_SUCCESS:
      return state.set("info", fromJS(action.data));
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/shared/redux/reducer.js